import React from 'react';
import styled from 'App/styled';


interface PageCountProps {
  currentPage: number;
  totalPage: number;
}
const Page = styled.span`
  ${({ theme }) => theme.typography.bodyLarge};
  position: absolute;
  left: 10px;
  color: #3f414d;
`;

const PageCount = ({ currentPage, totalPage }: PageCountProps) => {
  const text = `Page ${currentPage} of ${totalPage}`;
  return <Page>{text}</Page>;
};

export default PageCount;
